// extracted by mini-css-extract-plugin
module.exports = {"observer":"ResizeObserver_observer__1SyxC"};